import React from 'react';

const ArticleSubMenuHeader = ({ subnavigationMenuTitle }) => {
  return <h3 className="article-submenu__header">{subnavigationMenuTitle}</h3>;
};

export default ArticleSubMenuHeader;
